import { Flags, Permissions, SegFlags } from "../../common/providers";

export default ({ projectId }) => [
	{
		name: "navigation:home.documents",
		to: `/projects/${projectId}/documents`,
		segFlag: SegFlags.DOCUMENT_CENTER_READING,
		flag: Flags.DOCUMENT_CENTER,
		allowedEnvironments: ["dev", "qa", "prod", "veolia"],
	},
	{
		name: "navigation:home.team",
		to: `/projects/${projectId}/team`,
		flag: Flags.PARTNERS,
		segFlag: SegFlags.TEAM,
		allowedEnvironments: ["dev", "qa", "prod"],
	},
	{
		name: "navigation:home.admin-categories",
		to: `/projects/${projectId}/project-categories`,
		flag: Flags.THEMATIC,
		segFlag: SegFlags.CATEGORY,
		allowedEnvironments: ["dev", "qa", "prod"],
	},
	{
		name: "navigation:home.rights-on-documents",
		to: `/projects/${projectId}/rights-on-documents`,
		segFlag: [SegFlags.RIGHTS_ON_DOCUMENTS, SegFlags.TEAM],
		allowedEnvironments: ["dev", "qa", "prod"],
	},
	{
		name: "navigation:home.project-phases",
		to: `/projects/${projectId}/project-phases`,
		segFlag: [SegFlags.DELIVERABLES],
		companyRole: [Permissions.PROJECT_LEADER, Permissions.COMPANY_ADMIN],
	},
];
